import { BrowserRouter, Route, Routes } from "react-router-dom";
import LandingPage from "./containers/LandingPage";
import SplitChoice from "./containers/SplitChoice";
import GraphDetailsLight from "./containers/Graph/GraphDetailsLight";
import DarkWarning from "./containers/DarkWarning";
import Login from "./containers/Login";
import QuestionsPage from "./containers/QuestionsPage";
import GraphDetailsDark from "./containers/Graph/GraphDetailsDark";
import Sangati from "./containers/Sangati";
import Activity from "./components/Activity";
import Camera from "./containers/Camera";
import TermsAndConditions from "./containers/TermsAndConditions";
import PrivacyPolicy from "./containers/PrivacyPolicy";
import RefundAndCancellation from "./containers/RefundAndCancellation";
import ContactUs from "./containers/ContactUs";
import ProtectedRoute from "./containers/ProtectedRoutes";
import { FC } from "react";
import Contact from "./containers/Contact";
import CheckoutForm from "./components/Bank/Stripe/StripeCheckout";
import Return from "./components/Bank/Stripe/StripeReturn";
import SearchPage from "./containers/SearchPage";

const App: FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/choose" element={<SplitChoice />} />

        <Route element={<ProtectedRoute />}>
          <Route path="/sangati" element={<Sangati />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/stripe/checkout" element={<CheckoutForm />} />
          <Route path="/stripe/success" element={<Return />} />
        </Route>
        <Route path="/contact" element={<Contact />} />
        <Route path="/camera" element={<Camera />} />
        <Route path="/activity" element={<Activity />} />
        <Route path="/graph-details-dark" element={<GraphDetailsDark />} />
        <Route path="/graph-details-light" element={<GraphDetailsLight />} />
        <Route path="/dark-warning" element={<DarkWarning />} />
        <Route path="/questionnaire" element={<QuestionsPage />} />
        <Route path="/terms-and-condition" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route
          path="/refund-and-cancellation"
          element={<RefundAndCancellation />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
